export enum OrderEnum {
    ASK = "ASC",
    DESC = "DESC",
}

export enum ProductListHeadlines {
    ID = "id",
    TITLE = "title",
    DESCRIPTION = "description",
    PRICE = "price",
    RATING = "rating",
    STOCK = "stock",
    CATEGORY = "category",
}
